<template>

  <div :class="{'box-loading': loading}">
    <h5 class="mb-3">{{ $t('Scorecard templates') }}</h5>
    <div
      v-if="scoreforms.length"
      class="list-group mb-3">
      <a
        class="list-group-item list-group-item-action"
        :style="{ 'pointer-events': permissions.includes('manage_jobs') ? 'auto' : 'none' }"
        v-for="(item, index) in scoreforms"
        :key="index"
        @click="showEditModal(item)"
        href="javascript:void(0)">
        {{ item.name }}
      </a>
    </div>
    <button
      v-if="permissions.includes('manage_jobs')"
      type="button"
      class="btn btn-primary"
      @click="showCreateModal()">
      + {{ $t('New template') }}
      </button>
    <JobProfileScoreformsModalForm
      v-if="modal_select"
      :initScoreform="modal_select"
      :jobId="job._id"
      @hideModal="hideModal ()" 
      @deleted="loadData(); hideModal()" 
      @saved="loadData(); hideModal()" />
  </div>

</template>

<script>
import JobProfileScoreformsModalForm from './JobProfileScoreformsModalForm'

export default {
  name: 'JobProfileScoreforms',
  components: {
    JobProfileScoreformsModalForm
  },
  props: {
    job: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      modal_select: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    scoreforms () {
      return this.$store.getters.getJobScoreforms
    }
  },
  methods: {
    /* loadData  */
    loadData () {
      this.loading = true

      this.$store
      .dispatch('selectJobScoreforms', {
        job_id: this.job._id,
        sort: 'created_at'
      })
      .then(() => {
        this.loading = false
      })
    },
    /*
    modal
    */
    showCreateModal () {
      this.modal_select = {}
    },
    showEditModal (item) {
      this.modal_select = item
    },
    hideModal () {
      this.modal_select = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Job/JobProfile/JobProfileScoreforms.vue